// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".s-key-events__input{opacity:0;position:fixed;left:500px}\n", ""]);
// Exports
module.exports = exports;
